function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "31.789,34.964 37.353,48.743 39.21,71.78 37.353,79.73 46.894,96.949 52.456,112.046  51.923,114.171 66.229,124.772 68.88,123.981 71.796,130.053 66.758,139.864 69.404,149.667 64.906,166.354 61.715,165.557  43.19,185.424 52.984,189.933 56.958,188.078 61.715,196.553 64.906,197.344 77.63,177.481 88.21,177.481 98.804,170.333  103.32,169.539 117.095,178.802 121.328,178.275 143.849,200 149.416,165.557 147.023,162.906 149.416,157.083 160.009,156.286  165.57,151.783 168.211,142.513 149.416,127.418 153.119,122.119 149.929,103.574 136.43,83.707 140.134,69.131 136.954,49.532  126.354,50.863 118.147,46.889 113.909,34.17 105.691,29.667 91.917,36.295 84.512,36.295 82.654,31.519 88.21,25.175  81.332,10.591 81.858,7.162 51.923,0 45.566,3.971 47.418,9.792 46.103,31.519 49.275,38.943 40.539,39.47 33.649,32.85 "
});

var Svg18 = function Svg18(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NAY",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg18, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/18.1cbe5478.svg";
export { ForwardRef as ReactComponent };